import Api from './Api';

const endpoint = '/fibu/buchungsstapel';

export default {
    abort() {
        Api.abort(abortKey);
    },
    get() {
        return Api.fetchData(endpoint);
    },
    getSingle(id) {
        return Api.fetchData(endpoint + '/' + id);
    },
    getRelated(id) {
        return Api.fetchData(endpoint + '/verwalten/' + id);
    },
    put(id, data) {
        return Api.putData(endpoint + '/' + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    postBuchungsstapel(id, data) {
        return Api.postData(endpoint + '/buchen/' + id, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + '/' + id);
    }
};